module.exports = __webpack_public_path__ + "static/media/vw-t40.b46f5331.jpg";